import * as React from "react";
import { Portfolio } from "../../../models";

export interface PortfolioItemProps {
  portfolio: Portfolio;
}

const PortfolioItem = ({ portfolio }: PortfolioItemProps): JSX.Element => (
  <div className="portfolio-carousel__item">
    <img
      className="img-responsive"
      src={portfolio.image}
      alt={portfolio.name}
    />
  </div>
);

export default PortfolioItem;



// WEBPACK FOOTER //
// ./src/routes/PortfolioCarousel/components/PortfolioItem.tsx